import * as React from "react";
import { Box, Typography, IconButton, Tooltip, Avatar, Menu, MenuItem, ListItemIcon, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Logout from "@mui/icons-material/Logout";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import BusinessIcon from "@mui/icons-material/Business";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const Header: React.FC = () => {
  const navigate = useNavigate();
  const firstName = localStorage.getItem("first_name") || "User";
  const lastName = localStorage.getItem("last_name") || "";
  const companyName = localStorage.getItem("company_name");
  const userName = localStorage.getItem("user_name") || "No Name";
  const email = localStorage.getItem("email");
  const phoneNumber = localStorage.getItem("phone_number");
  const location = localStorage.getItem("location_name");

  // Menu State
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  // Handlers
  const handleClick = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const logout = async () => {
    localStorage.clear();
    navigate("/");
  };

  const getCapitalizedName = (name: string): string =>
    name ? name.charAt(0).toUpperCase() + name.slice(1) : "";

  return (
    <header style={{ padding: 20, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <Box className="d-flex justify-start flex-direction-column">
        <p className="dark-blue fs-22 fw-bold">
          Welcome <span>{getCapitalizedName(firstName)} {getCapitalizedName(lastName)}!</span>
        </p>
      </Box>

      {/* Profile Menu */}
      <React.Fragment>
        <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
          <Tooltip title="Profile">
            <IconButton onClick={handleClick} size="medium" sx={{ ml: 2 }} aria-haspopup="true" aria-expanded={open ? "true" : undefined}>
              <Avatar className="bg-blue" sx={{ width: 40, height: 40 }}>
                {userName.charAt(0).toUpperCase()}
              </Avatar>
            </IconButton>
          </Tooltip>
        </Box>

        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <Box
            className="d-flex align-center flex-direction-column"
            style={{ minWidth: 250, gap: 6, textAlign: "center" }}
          >
            <Avatar className="bg-blue m-t-20" sx={{ width: 50, height: 50 }}>
              <p>{getCapitalizedName(firstName).charAt(0)}</p>
            </Avatar>

            {/* Name */}
            <Typography variant="h6" fontWeight="bold">
              {getCapitalizedName(firstName)} {getCapitalizedName(lastName)}
            </Typography>

            {/* Email or Phone */}
            <Box className="d-flex align-center" style={{ gap: 6 }}>
              {email ? <EmailIcon fontSize="small" /> : <PhoneIcon fontSize="small" />}
              <Typography variant="body2" noWrap>
                {email ? email : phoneNumber}
              </Typography>
            </Box>

            {/* Company Name (with wrapping) */}
            <Box
              className="d-flex align-center"
              style={{ gap: 6, maxWidth: 220, textAlign: "center" }}
            >
              <BusinessIcon fontSize="small" />
              <Typography
                variant="body2"
                style={{ wordBreak: "break-word", whiteSpace: "normal" }}
              >
                {companyName}
              </Typography>
            </Box>

            {/* Location */}
            {location && (
              <Box className="d-flex align-center" style={{ gap: 6 }}>
                <LocationOnIcon fontSize="small" />
                <Typography variant="body2">{location}</Typography>
              </Box>
            )}
          </Box>
          <Divider className="m-t-20" />
          <MenuItem onClick={logout}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </React.Fragment>
    </header>
  );
};

export default Header;
